import { apiClient } from './ApiClient';

export const checkEC2StatusAPI = async (instanceId, includeScript = false) => {
    const response = await apiClient.post("modeltesting", {
        action: "getStatus",
        region: "us-east-1",
        instanceId,
        includeScript
      });
    return response.data;
};

export const startEC2API = async (instanceId, objectName) => {
    const response = await apiClient.post("modeltesting", {
        action: "startEC2",
        region: "us-east-1",
        instanceId: instanceId,
        objectName: objectName
      });
    return response.data;
};


export const stopEC2API = async (instanceId) => {
    const response = await apiClient.post("modeltesting", {
        action: "stopEC2",
        region: "us-east-1",
        instanceId: instanceId
      });
    return response.data;
};


export const triggerDownloadForInferenceToEC2 = async (instanceId, organization, datePrefix, fileList) => {
  const payload = {
    action: "downloadForInference",
    instanceId: instanceId,
    organization,
    datePrefix,
    fileList
  };

  try {
    const response = await apiClient.post('modeltesting', payload);
    return response.data;
  } catch (error) {
    console.error("Error triggering inference download:", error);
    throw error;
  }
};


export const fetchFilesAPI = async (organization, startDate, endDate) => {
  const payload = {
    action: "fetchFiles",
    organization,
    startDate,
    endDate
  };

  const response = await apiClient.post('modeltesting', payload );
  const files = response.data.message;
  console.log(files);
  return { files };
};


export const getPresignedUrlAPI = async (organization, fileUrl) => {
  console.log(fileUrl);
  const payload = {
    action: "getPresignedUrl",
    organization,
    fileUrl
  };
  const response = await apiClient.post('modeltesting', payload);
  return response.data;
};


export const triggerInferenceFileWatcherAPI = async (organization, s3FolderPrefix, expectedFiles) => {
  const response = await apiClient.post('modeltesting', {
    action: "startInferenceFileWatcher",
    organization,
    s3Prefix: s3FolderPrefix,
    fileList: expectedFiles
  });
  return response.data; // Expected: { "file1.jpg": "https://...", ... }
};


export const startDetectionScriptAPI = async (instanceId, objectName) => {
  const response = await apiClient.post("modeltesting", {
    action: "startDetectionScript",
    region: "us-east-1",
    instanceId,
    objectName,
  });
  return response.data;
};


export const stopDetectionScriptAPI = async (instanceId, objectName) => {
  const response = await apiClient.post("modeltesting", {
    action: "stopDetectionScript",
    region: "us-east-1",
    instanceId,
    objectName,
  });
  return response.data;
};


export const getDectectionScriptStatusAPI = async (instanceId) => {
  const response = await apiClient.post("modeltesting", {
    action: "getDetectionScriptStatus",
    region: "us-east-1",
    instanceId,
  });
  return response.data;
};


export const listModelsAPI = async (organization) => {
  const payload = { action: "listAvailableModels", organization };
  const response = await apiClient.post("modeltesting", payload);
  const files = response.data.message;
  return { files };
};


export const orchestrateKVSStackAPI = async (
  instanceId,
  op, // "start" | "stop"
  { streamName, organization, region = "us-east-1", outBucket } = {}
) => {
  const payload = {
    action: "orchestrateKvsStack",
    instanceId,
    region,
    op,
    streamName,
    organization,
    outBucket, // optional; backend will default to env bucket if omitted
  };
  const { data } = await apiClient.post("modeltesting", payload);
  return data; // { message: "dispatched" | "error" }
};

/** List only ready (paired) frames for a given UTC date (YYYY/MM/DD) */
export const listReadyPairsAPI = async (organization, date, pageSize = 200, cursor) => {
  const payload = { action: "listReadyPairs", organization, date, pageSize, cursor };
  const { data } = await apiClient.post("modeltesting", payload);
  return data?.message; // { items, nextCursor }
};